import React, { useMemo } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const { name, minutos } = payload[0].payload;
        return (
            <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: "5px" }}>
                <p><strong>Colegio:</strong> {name}</p>
                <p><strong>Minutos:</strong> {minutos}</p>
            </div>
        );
    }
    return null;
};

function RankingBarrasColegios({ data, title = "Top 10 Colegios más activos", type = "TOP", barColor = "#ff7300" }) {
    // 1) Agrupar por colegio (institution_name o category_name como fallback)
    const groupedData = useMemo(() => {
        const map = {};
        data.forEach(item => {
            // Fallback: si no hay institution_name, usar category_name.
            const colegio = item.institution_name || item.category_name || "Desconocido";

            if (!map[colegio]) {
                map[colegio] = 0;
            }
            map[colegio] += Number(item.active_seconds);
        });

        // Sort
        const list = Object.entries(map).map(([name, seconds]) => ({
            name,
            minutos: Math.round(seconds / 60)
        }));

        const sorted = list.sort((a, b) => b.minutos - a.minutos);

        if (type === "BOTTOM") {
            // "Menos activos" = los últimos de la lista ordenada descendente (b-a)
            // slice(-10) toma los últimos 10. reverse() para mostrarlos en orden visual.
            return sorted.slice(-10).reverse();
        }

        // TOP default
        return sorted.slice(0, 10);

    }, [data, type]);

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <h2 style={{ textAlign: "center", fontSize: "1.2rem", color: "#003366" }}>{title}</h2>
            <ResponsiveContainer width="100%" height={400}>
                <BarChart
                    data={groupedData}
                    layout="vertical"
                    margin={{ top: 20, right: 20, left: 10, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis style={{ fontSize: '0.8rem' }} dataKey="name" type="category" width={220} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="minutos" fill={barColor} radius={[0, 4, 4, 0]} barSize={20} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default RankingBarrasColegios;
